// extracted by mini-css-extract-plugin
export default {"card":"done-card_card__huFnu","card__text":"done-card_card__text__lNLRd","card__icon":"done-card_card__icon__qrwp9"};